<template lang="pug">
  div(class="text-xs-center")
    v-dialog(
      v-model="dialog"
      persistent
      width="300"
    )
      v-card(
        color="primary"
        dark
      )
        v-card-text() Loading
          v-progress-linear(
            indeterminate
            color="white"
            class="mb-0"
            )
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Loader',
    data() {
        return {
            dialog: false
        };
    },
    computed: {
        ...mapState({
            cursor: state => state.appearance.cursor,
        }),
    },

    watch: {
        cursor(value) {
            switch (value) {
                case 'progress':
                    this.dialog = true;
                    break;
                default:
                    this.dialog = false;
                    break;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/core/Loader.vue